import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SharedService } from './sharedService';
import { catchError, map, timeout } from 'rxjs/operators';
import { BaseService } from './base.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
 
export class DocTemplateService extends BaseService{

  constructor(public http: HttpClient, public sharedService: SharedService) { 
    super(http, sharedService);
  }

  getDocTemplateByType(template): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('doc-template/type/'+template)).pipe(
      map(res => {
        return res;
      })
    );
  }
}
